/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Key, Key$inboundSchema } from "./key.js";

export type ListKeysResult = {
  keys: Array<Key>;
};

/** @internal */
export const ListKeysResult$inboundSchema: z.ZodMiniType<
  ListKeysResult,
  unknown
> = z.object({
  keys: z.array(Key$inboundSchema),
});

export function listKeysResultFromJSON(
  jsonString: string,
): SafeParseResult<ListKeysResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListKeysResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListKeysResult' from JSON`,
  );
}
